import { defineComponent } from "vue";
import {
    LogscordComparisonCards,
    LogscordComparisonRows,
} from "@logscord/public-site-config";
import {
    PublicFooter,
    PublicNavbar,
} from "./PublicShell.js";
import { useLocale } from "../../locales/i18n.js";


//////////////////////////////////////////////////
//  COMPARE
//////////////////////////////////////////////////


export default defineComponent({
    setup() {
        const { i18n } = useLocale();

        return () => (
            <div class="public-page public-compare-page">
                <PublicNavbar />

                <div class="public-hero">
                    <span class="landing-kicker">{i18n("compare.hero.kicker")}</span>
                    <h1>{i18n("compare.hero.title")}</h1>
                    <p>{i18n("compare.hero.description")}</p>
                </div>

                <div class="comparison-summary-grid">
                    {LogscordComparisonCards.map((card) => (
                        <div>
                            <i class="material-symbols-outlined">{card.icon}</i>
                            <h2>{i18n(card.titleKey)}</h2>
                            <p>{i18n(card.descriptionKey)}</p>
                        </div>
                    ))}
                </div>

                <div class="comparison-table-card">
                    <div class="comparison-table-head">
                        <div>{i18n("compare.table.capability")}</div>
                        <div>{i18n("compare.table.logscord")}</div>
                        <div>{i18n("compare.table.classic")}</div>
                    </div>

                    {LogscordComparisonRows.map(([ labelKey, logscordKey, classicKey ]) => (
                        <div class="comparison-table-row">
                            <div>{i18n(labelKey)}</div>
                            <div>
                                <i class="material-symbols-outlined">check_circle</i>
                                <span>{i18n(logscordKey)}</span>
                            </div>
                            <div>
                                <i class="material-symbols-outlined">radio_button_unchecked</i>
                                <span>{i18n(classicKey)}</span>
                            </div>
                        </div>
                    ))}
                </div>

                <PublicFooter />
            </div>
        );
    },
});
